import {
  ScrollAreaProps as MantineScrollAreaProps,
  ScrollArea as MantineScrollArea,
} from '@mantine/core';

export type ScrollAreaProps = MantineScrollAreaProps;

export const ScrollArea = MantineScrollArea;

ScrollArea.displayName = 'ScrollArea';
